/** True when the app is served from a local dev hostname (e.g. localhost:4210). */
export function isLocalhostDevHostname(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const h = (window.location.hostname || "").trim().toLowerCase();
  return h === "localhost" || h === "127.0.0.1";
}
